import { useState } from 'react';

import LoggedInCustomer from '../../../types/LoggedInCustomer';
import DisplayOptions from '../../LoginAndForgotPasswordCard/types/DisplayOptions';

type Options = {
    loggedInCustomer?: LoggedInCustomer;
    enabled?: boolean;
    defaultDisplay?: DisplayOptions;
};

const useLoginForm = ({
    loggedInCustomer,
    enabled = false,
    defaultDisplay,
}: Options) => {
    /**
     * Login stuff
     */
    const [loginFormClosed, setLoginFormClosed] = useState(
        defaultDisplay === 'hidden'
    );

    const toggleLoginForm = () => setLoginFormClosed(!loginFormClosed);
    const hideLoginForm = () => setLoginFormClosed(true);

    const loginFormDisplay: DisplayOptions = (() => {
        if (loggedInCustomer) {
            return 'hidden';
        }

        if (defaultDisplay === 'force') {
            return 'force';
        }

        return loginFormClosed ? 'hidden' : 'optional';
    })();

    return {
        toggle: enabled ? toggleLoginForm : undefined,
        hide: hideLoginForm,
        display: loginFormDisplay,
    };
};

export default useLoginForm;
